import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import * as moment from "moment";
import * as R from "ramda";
import { Row, Col, Container } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { FiletypeCsv } from "react-bootstrap-icons";
import DateTimePicker from "react-datetime-picker";
import calendarIcon from "../../images/dashboard/Calendar_icon.png";
import ConfirmDelete from "../ui/ConfirmDelete";
import { toDecimal } from "../../utils";
import {
  jobHandleForm,
  jobDetailCreate,
  jobDelete,
  jobDetailDelete,
  jobNotifyCustomer,
} from "../arsenal/arsenal.redux";
import NotifyCustomerModal from "../dashboard/NotifyCustomerModal";
import { DebounceInput } from "react-debounce-input";
import { getCustomer } from "../bowlers/bowlers.redux";
import styled from "styled-components";
import "./styles.css";
import "react-datetime-picker/dist/DateTimePicker.css";
import SpinnerService from "./Spinner";
import Spinner from "../ui/Spinner";
import Image from "../ui/Image";
import { getPhotoForUserId } from "../../utils/utils";
import BallShadow from "../../images/arsenal_shadow.png";
import ballImageDefault from "../../images/default_ball.png";
import {
  BoxArrowUpRight,
  PersonUp,
  ClipboardCheck,
  XCircle,
} from "react-bootstrap-icons";
import { Select } from "antd";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import { woocommerceCheckUserExists } from "../plugins/plugin.redux";
import { BowlerHeader } from "../ui/BowlerHeader";

const JobFormNoteLazy = React.lazy(() => import("./jobFormNote.jsx"));

const DebounceInputStyled = styled(DebounceInput)`
  width: 100px;
  height: 96px;
  font-size: 50px;
  font-weight: 600;
}`;

const dropdownStyle = {
  width: "100%",
  minWidth: "250px",
  height: 48,
  color: "#00197B",
  marginBottom: "2vh",
};

const DateTimePickerInput = styled(DateTimePicker)`
  width: 245px;
  height: 48px;
  background-color: #e0e1e2;
  padding-left: 10px;
  border-radius: 5px;

  & .react-datetime-picker__wrapper {
    border-radius: 5px;
    border: none;
  }
`;
const customerNameStyle = {
  font: "normal normal bold 20px / 28px Lato",
  letterSpacing: "0px",
  color: "#000000",
  opacity: "1",
  fontWeight: "700",
  order: 1,
};

const marginRules = {
  width: "100%",
  maxWidth: "1024px",
  margin: "4vh 6vw 30vh 6vw",
};

const imageBall = {
  width: "100%",
  height: "auto", // Maintain aspect ratio
  maxHeight: "100%", // Restrict the height to the container
  objectFit: "contain",
};

const titleStyle = {
  font: "normal normal bold 28px / 36px Lato",
  letterSpacing: "0px",
  color: "#000000",
  opacity: "1",
  fontWeight: "700",
  display: "block",
};

const Label = styled.div`
  font: 14px;
  font-weight: 600;
  letter-spacing: 0px;
  color: #000000;
  margin-top: 1em;
  margin-bottom: 1em;
`;

const LabelService = styled.div`
  text-align: center;
  font-size: 20px;
  letter-spacing: 0px;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
`;

const LabelServicePrice = styled.div`
  text-align: center;
  font-size: 30px;
  font-weight: 600;
  letter-spacing: 0px;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
`;

const LabelTotal = styled.div`
  text-align: left;
  font-size: 50px;
  font-weight: 600;
  letter-spacing: 0px;
  color: #000000;
  margin-left: 5px;
`;

const ButtonDeleteJob = styled.button`
  font-size: 13px;
  font-weight: 600;
  border-radius: 8px;
  background: #dc3545;
  color: #ffffff;
  width: 100%;
  min-height: 40px;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 6px 12px;

  &:hover {
    background: #c82333;
  }
`;

const ButtonCompleteJob = styled.button`
  font-size: 13px;
  font-weight: 600;
  border-radius: 8px;
  background: #28a745;
  color: #ffffff;
  width: 100%;
  min-height: 40px;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 6px 12px;

  &:hover {
    background: #218838;
  }
`;

const ButtonPendingPickUp = styled.button`
  font-size: 13px;
  font-weight: 600;
  border-radius: 8px;
  background: #5d8fe0;
  color: #ffffff;
  width: 100%;
  min-height: 40px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 6px 12px;

  &:hover {
    background: #3d7ad8;
  }
`;

const ShadowImage = styled.div`
  position: absolute;
  bottom: -13px;
  background-image: url(${BallShadow});
  background-repeat: no-repeat;
  background-position: center center;
  width: 100%;
  height: 25px;
  background-size: 100% 25px;
`;

const ImageContainer = styled.div`
  padding: 4px;
  width: 100%;
  max-width: 200px;
  aspect-ratio: 137.07 / 146.69;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

const ImageDiv = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 137.07 / 146.69;
  overflow: visible;
  display: flex;
  justify-content: center;
  align-items: flex-end;
`;

const ServiceDiv = styled.div`
  height: 100px;
  border: 1px solid #17a2b8;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  margin-bottom: 10px;
  margin-top: 10px;
  color: ${(props) => (props.selected ? "#ffffff" : "#17a2b8")};
  font-size: 20px;
  text-align: center;
  background-color: ${(props) => (props.selected ? "#17a2b8" : "#ffffff")};
`;

const DateTimePickerDiv = styled.div`
  width: 200px;
  height: 48px;
  background-color: #e0e1e2;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-contensales_persont: center;
  font-size: 20px;
  color: #5a5a5a;
`;

export const JobBoardBallServiceScreenRedux = (props) => {
  const {
    userId,
    getCustomer,
    loadingCustomer,
    currentBall,
    selectedCustomer,
    isReadOnly,
    currentJob,
    jobServices,
    jobDetailCreate,
    selectedJobServices,
    total,
    plugin_settings,
    pluginSubscriptions,
    salesPersons,
    locations,
    currentSpecsheet,
    jobHandleForm,
    jobDelete,
    jobDetailDelete,
    jobNotifyCustomer,
    isCompleted,
    creatingJobDetails,
    spanMeasurement,
    woocommerceCheckUserExists,
  } = props;

  const [showConfirmPendingPickup, setShowConfirmPendingPickup] =
    useState(false);
  // Asked after the job has moved but before leaving the screen (#855) --
  // navigating away first would take the prompt with it.
  const [showNotifyCustomer, setShowNotifyCustomer] = useState(false);
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [showConfirmComplete, setShowConfirmComplete] = useState(false);

  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const bowlerID = params.bowlerID;
  const ballID = params.ballID;
  const jobID = params.jobID;

  useEffect(() => {
    if (!loadingCustomer) {
      getCustomer({
        customer_id: bowlerID,
        setCurrentball: ballID,
        setCurrentJob: jobID,
      });
    }
  }, []);

  const selectedBall = currentBall || {};
  const { ball_name, photo, weight, serial_number } = selectedBall;

  const getPhoto = getPhotoForUserId(userId);
  const image = getPhoto(photo);

  return loadingCustomer ? (
    <Spinner />
  ) : (
    <>
      <BowlerHeader />
    <div style={marginRules}>
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6} lg={6} xl={6} style={{ textAlign: "center" }}>
            <span style={titleStyle}>{t("general.arsenal")}</span>
            <Label>
              {`${t(
                "jobBoard.selectedServicesFor"
              )}: ${ball_name} - ${weight} lbs - ${serial_number}`}
            </Label>
          </Col>
          <Col xs={6} md={3} lg={3} xl={3}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
              }}
            >
              <ImageContainer>
                <ImageDiv>
                  <Image
                    style={imageBall}
                    src={image === null ? ballImageDefault : image}
                    fluid={"true"}
                    alt={""}
                    wrapperProps={{ style: { height: "unset", width: "100%" } }}
                    placeholderSrc={ballImageDefault}
                  />
                  <ShadowImage />
                  <Link
                    to={`/arsenal/${selectedCustomer?.id}/ball/${ballID}`}
                    style={customerNameStyle}
                  >
                    <BoxArrowUpRight
                      style={{
                        fontSize: 20,
                        verticalAlign: "-0.03em",
                        textAlign: "left",
                        marginLeft: 4,
                      }}
                    />
                  </Link>
                </ImageDiv>
              </ImageContainer>
            </div>
          </Col>
          <Col xs={6} md={3} lg={3} xl={3}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
                justifyContent: "center",
                gap: 8,
                height: "100%",
              }}
            >
              {/* {pluginSubscriptions.indexOf("BOWLER_PLUS") >= 0 && (
                <>
                  <div>
                    <ButtonPendingPickUp
                      onClick={() => {
                        const layout = currentBall?.layout?.split("X");
                        const drilling_angle = layout?.[0].trim() || "";
                        const pin_to_pap = layout?.[1].trim() || "";
                        const val_angle = layout?.[2].trim() || "";
                        const rows = [
                          ["JobNumber", currentJob?.id],
                          ["JobComplete", false],
                          ["FirstName", selectedCustomer?.firstname || ""],
                          ["LastName", selectedCustomer?.lastname || ""],
                          [
                            "RightHanded",
                            currentBall?.customer?.hand === "right_hander"
                              ? true
                              : false,
                          ],
                          ["BallName", ball_name || ""],
                          ["Weight", toDecimal(weight, spanMeasurement) || ""],
                          ["Serial", serial_number || ""],
                          ["Symmetric", false],
                          [
                            "PinToPap",
                            toDecimal(pin_to_pap, spanMeasurement) || "",
                          ],
                          ["DrillingAngle", drilling_angle || ""],
                          ["ValAngle", val_angle || ""],
                          [
                            "PapHorizontal",
                            toDecimal(
                              selectedCustomer?.pap_h,
                              spanMeasurement
                            ) || "",
                          ],
                          [
                            "PapVertical",
                            toDecimal(
                              selectedCustomer?.pap_v,
                              spanMeasurement
                            ) || "",
                          ],
                          [
                            "MiddleSpan",
                            toDecimal(
                              currentSpecsheet?.f1_span_cut,
                              spanMeasurement
                            ) || "",
                          ],
                          [
                            "RingSpan",
                            toDecimal(
                              currentSpecsheet?.f2_span_cut,
                              spanMeasurement
                            ) || "",
                          ],
                          [
                            "Bridge",
                            toDecimal(
                              currentSpecsheet?.bridge,
                              spanMeasurement
                            ) || "",
                          ],
                          [
                            "LeftSpan",
                            toDecimal(
                              currentSpecsheet?.f1_span_cut,
                              spanMeasurement
                            ) || "",
                          ],
                          [
                            "RightSpan",
                            toDecimal(
                              currentSpecsheet?.f2_span_cut,
                              spanMeasurement
                            ) || "",
                          ],
                          ["LeftDepth", currentBall?.f1_depth || 2],
                          [
                            "LeftMinor",
                            currentSpecsheet?.f1_oval
                              ? toDecimal(
                                  currentSpecsheet?.f1_oval,
                                  spanMeasurement
                                ) || ""
                              : toDecimal(
                                  currentSpecsheet?.f1_size,
                                  spanMeasurement
                                ) || "",
                          ],
                          [
                            "LeftMajor",
                            toDecimal(
                              currentSpecsheet?.f1_size,
                              spanMeasurement
                            ) || "",
                          ],
                          ["LeftAngle", ""],
                          [
                            "LeftFwdRev",
                            currentSpecsheet?.f1_for
                              ? "+" +
                                toDecimal(
                                  currentSpecsheet?.f1_for,
                                  spanMeasurement
                                )
                              : currentSpecsheet?.f1_rev
                              ? "-" +
                                toDecimal(
                                  currentSpecsheet?.f1_rev,
                                  spanMeasurement
                                )
                              : "",
                          ],
                          [
                            "LeftRgtLft",
                            currentSpecsheet?.f1_lat_r
                              ? "+" +
                                toDecimal(
                                  currentSpecsheet?.f1_lat_r,
                                  spanMeasurement
                                )
                              : currentSpecsheet?.f1_lat_l
                              ? "-" +
                                toDecimal(
                                  currentSpecsheet?.f1_lat_l,
                                  spanMeasurement
                                )
                              : "",
                          ],
                          ["RightDepth", currentBall?.f2_depth || 2],
                          [
                            "RightMinor",
                            currentSpecsheet?.f2_oval
                              ? toDecimal(
                                  currentSpecsheet?.f2_oval,
                                  spanMeasurement
                                ) || ""
                              : toDecimal(
                                  currentSpecsheet?.f2_size,
                                  spanMeasurement
                                ) ||
                                "" ||
                                "",
                          ],
                          [
                            "RightMajor",
                            toDecimal(
                              currentSpecsheet?.f2_size,
                              spanMeasurement
                            ) || "",
                          ],
                          ["RightAngle", ""],
                          [
                            "RightFwdRev",
                            currentSpecsheet?.f2_for
                              ? "+" +
                                toDecimal(
                                  currentSpecsheet?.f2_for,
                                  spanMeasurement
                                )
                              : currentSpecsheet?.f2_rev
                              ? "-" +
                                toDecimal(
                                  currentSpecsheet?.f2_rev,
                                  spanMeasurement
                                )
                              : "",
                          ],
                          [
                            "RightRgtLft",
                            currentSpecsheet?.f2_lat_r
                              ? "+" +
                                toDecimal(
                                  currentSpecsheet?.f2_lat_r,
                                  spanMeasurement
                                )
                              : currentSpecsheet?.f2_lat_l
                              ? "-" +
                                toDecimal(
                                  currentSpecsheet?.f2_lat_l,
                                  spanMeasurement
                                )
                              : "",
                          ],
                          ["ThumbType", currentSpecsheet?.thm_type || ""],
                          ["ThumbDepth", currentBall?.thumb_depth || 2.75],
                          [
                            "ThumbMinor",
                            currentSpecsheet?.thm_type === "Oval"
                              ? toDecimal(
                                  currentSpecsheet?.thm_oval_width,
                                  spanMeasurement
                                )
                              : toDecimal(
                                  currentSpecsheet?.thm_round_taper,
                                  spanMeasurement
                                ) || "",
                          ],
                          [
                            "ThumbMajor",
                            currentSpecsheet?.thm_type === "Oval"
                              ? toDecimal(
                                  currentSpecsheet?.thm_oval_taper,
                                  spanMeasurement
                                )
                              : toDecimal(
                                  currentSpecsheet?.thm_round_taper,
                                  spanMeasurement
                                ) || "",
                          ],
                          [
                            "ThumbAngle",
                            currentSpecsheet?.thm_type === "Oval"
                              ? currentSpecsheet?.thm_oval_degree || ""
                              : "0",
                          ],
                          [
                            "ThumbFwdRev",
                            currentSpecsheet?.thm_for
                              ? "+" +
                                toDecimal(
                                  currentSpecsheet?.thm_for,
                                  spanMeasurement
                                )
                              : currentSpecsheet?.thm_rev
                              ? "-" +
                                toDecimal(
                                  currentSpecsheet?.thm_rev,
                                  spanMeasurement
                                )
                              : "",
                          ],
                          [
                            "ThumbRgtLft",
                            currentSpecsheet?.thm_lat_r
                              ? "+" +
                                toDecimal(
                                  currentSpecsheet?.thm_lat_r,
                                  spanMeasurement
                                )
                              : currentSpecsheet?.thm_lat_l
                              ? "-" +
                                toDecimal(
                                  currentSpecsheet?.thm_lat_l,
                                  spanMeasurement
                                )
                              : "",
                          ],
                          [
                            "ThumbInsertType",
                            currentSpecsheet?.thm_insert_type || "",
                          ],
                          [
                            "ThumbInsertDiameter1",
                            toDecimal(
                              currentSpecsheet?.thm_od,
                              spanMeasurement
                            ) || "",
                          ],
                          [
                            "ThumbInsertDepth1",
                            currentBall?.thumb_depth || 2.75,
                          ],
                          [
                            "ThumbInsertDepth2",
                            currentBall?.thumb_depth || 2.75,
                          ],
                          [
                            "ThumbInsertDiameter2",
                            toDecimal(
                              currentSpecsheet?.thm_oval_starting_bit,
                              spanMeasurement
                            ) || "",
                          ],
                        ];
                        let csvContent =
                          "data:text/csv;charset=utf-8," +
                          rows.map((e) => e.join(",")).join("\n");

                        var encodedUri = encodeURI(csvContent);
                        var link = document.createElement("a");
                        link.setAttribute("href", encodedUri);
                        link.setAttribute(
                          "download",
                          "drillbot_" + currentBall?.id + ".csv"
                        );
                        document.body.appendChild(link); // Required for FF
                        link.click(); // This will download the data file.
                      }}
                    >
                      <FiletypeCsv
                        style={{ fontSize: "22px", marginRight: "10px" }}
                      />
                      {t("form.label.drillbot")}
                    </ButtonPendingPickUp>
                  </div>
                </>
              )} */}
              {!isCompleted && (
                <ButtonPendingPickUp
                  onClick={() => {
                    setShowConfirmPendingPickup(true);
                  }}
                >
                  <PersonUp style={{ fontSize: 30, marginLeft: 8 }} />
                  <div style={{ lineHeight: 1 }}>{t("jobBoard.waiting_pickup")}</div>
                </ButtonPendingPickUp>
              )}
              {!isCompleted && (
                <ButtonCompleteJob
                  onClick={() => {
                    setShowConfirmComplete(true);
                  }}
                >
                  <ClipboardCheck style={{ fontSize: 16, marginRight: 5 }} />
                  {t("jobBoard.complete")}
                </ButtonCompleteJob>
              )}
              <ButtonDeleteJob
                onClick={() => {
                  setShowConfirmDelete(true);
                }}
              >
                <XCircle style={{ fontSize: 16, marginRight: 5 }} />
                {t("jobBoard.delete")}
              </ButtonDeleteJob>
            </div>
          </Col>
        </Row>
      </Container>
      <Container>
        <Row>
          {jobServices.map((service) => (
            <Col xs={12} md={4} lg={3}>
              <ServiceDiv
                selected={R.contains(service.id, selectedJobServices)}
                onClick={() => {
                  if (isCompleted) return;
                  if (creatingJobDetails[service.id]) return;
                  if (R.contains(service.id, selectedJobServices)) {
                    if (
                      pluginSubscriptions.indexOf("SPECTRE_POS") >= 0 &&
                      service.sku
                    ) {
                      woocommerceCheckUserExists({
                        first_name: selectedCustomer.firstname,
                        last_name: selectedCustomer.lastname,
                        email: selectedCustomer.email,
                        spectreCustomer: selectedCustomer,
                        nextAction: "SKU remove",
                        sku: service?.sku,
                        customerData: {
                          first_name: selectedCustomer.firstname,
                          last_name: selectedCustomer.lastname,
                          email: selectedCustomer.email,
                          username: selectedCustomer.telephone,

                          billing: {
                            first_name: selectedCustomer.firstname,
                            last_name: selectedCustomer.lastname,
                            address_1: selectedCustomer.address,
                            city: selectedCustomer.city,
                            state: selectedCustomer.state,
                            postcode: selectedCustomer.postal_code,
                            country: selectedCustomer.country,
                            email: selectedCustomer.email,
                            phone: selectedCustomer.telephone,
                          },
                          shipping: {
                            first_name: selectedCustomer.firstname,
                            last_name: selectedCustomer.lastname,
                            address_1: selectedCustomer.address,
                            city: selectedCustomer.city,
                            state: selectedCustomer.state,
                            postcode: selectedCustomer.postal_code,
                            country: selectedCustomer.country,
                          },
                        },
                        orderData: {
                          payment_method: "bacs",
                          payment_method_title: "Direct Bank Transfer",
                          set_paid: false,
                          billing: {
                            first_name: selectedCustomer?.firstname,
                            last_name: selectedCustomer?.lastname,
                            address_1: selectedCustomer?.address,
                            address_2: "",
                            city: selectedCustomer?.city,
                            state: selectedCustomer?.state,
                            postcode: selectedCustomer?.postal_code,
                            country: selectedCustomer?.country,
                            email: selectedCustomer?.email,
                            phone: selectedCustomer?.telephone,
                          },
                          shipping: {
                            first_name: selectedCustomer?.firstname,
                            last_name: selectedCustomer?.lastname,
                            company: "",
                            address_1: selectedCustomer?.address,
                            address_2: "",
                            city: selectedCustomer?.city,
                            state: selectedCustomer?.state,
                            postcode: selectedCustomer?.postal_code,
                            country: selectedCustomer?.country,
                          },
                        },
                      });
                    }
                    jobDetailDelete({
                      id: R.find(
                        R.pathEq(["job_service", "id"], service.id),
                        currentJob.job_details
                      ).id,
                      job_service_id: service.id,
                    });
                  } else {
                    if (
                      pluginSubscriptions.indexOf("SPECTRE_POS") >= 0 &&
                      service.sku
                    ) {
                      woocommerceCheckUserExists({
                        first_name: selectedCustomer.firstname,
                        last_name: selectedCustomer.lastname,
                        email: selectedCustomer.email,
                        spectreCustomer: selectedCustomer,
                        nextAction: "SKU add",
                        sku: service?.sku,
                        customerData: {
                          first_name: selectedCustomer.firstname,
                          last_name: selectedCustomer.lastname,
                          email: selectedCustomer.email,
                          username: selectedCustomer.telephone,

                          billing: {
                            first_name: selectedCustomer.firstname,
                            last_name: selectedCustomer.lastname,
                            address_1: selectedCustomer.address,
                            city: selectedCustomer.city,
                            state: selectedCustomer.state,
                            postcode: selectedCustomer.postal_code,
                            country: selectedCustomer.country,
                            email: selectedCustomer.email,
                            phone: selectedCustomer.telephone,
                          },
                          shipping: {
                            first_name: selectedCustomer.firstname,
                            last_name: selectedCustomer.lastname,
                            address_1: selectedCustomer.address,
                            city: selectedCustomer.city,
                            state: selectedCustomer.state,
                            postcode: selectedCustomer.postal_code,
                            country: selectedCustomer.country,
                          },
                        },
                        orderData: {
                          payment_method: "bacs",
                          payment_method_title: "Direct Bank Transfer",
                          set_paid: false,
                          billing: {
                            first_name: selectedCustomer?.firstname,
                            last_name: selectedCustomer?.lastname,
                            address_1: selectedCustomer?.address,
                            address_2: "",
                            city: selectedCustomer?.city,
                            state: selectedCustomer?.state,
                            postcode: selectedCustomer?.postal_code,
                            country: selectedCustomer?.country,
                            email: selectedCustomer?.email,
                            phone: selectedCustomer?.telephone,
                          },
                          shipping: {
                            first_name: selectedCustomer?.firstname,
                            last_name: selectedCustomer?.lastname,
                            company: "",
                            address_1: selectedCustomer?.address,
                            address_2: "",
                            city: selectedCustomer?.city,
                            state: selectedCustomer?.state,
                            postcode: selectedCustomer?.postal_code,
                            country: selectedCustomer?.country,
                          },
                        },
                      });
                    }

                    // add code to add to the order here
                    jobDetailCreate({
                      service_id: service.id,
                      price: service.price,
                    });
                  }
                }}
              >
                {creatingJobDetails[service.id] && (
                  <SpinnerService
                    fill={
                      R.contains(service.id, selectedJobServices)
                        ? "#FFFFFF"
                        : "#17A2BB"
                    }
                  />
                )}
                {!creatingJobDetails[service.id] && (
                  <>
                    <LabelService>{service.name}</LabelService>
                    <LabelServicePrice>
                      {plugin_settings.job_board_include_price
                        ? `${service.price} ${plugin_settings.job_board_currency}`
                        : ""}
                    </LabelServicePrice>
                  </>
                )}
              </ServiceDiv>
            </Col>
          ))}
        </Row>
      </Container>
      {/* New Section for Staff Members and Locations go here */}
      <Container
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-evenly",
          marginTop: "2vh",
        }}
      >
        <FloatingLabel
          label={t("form.label.SalesPerson")}
          className="arsenal-select-floating-label"
        >
          <Select
            value={currentJob?.sales_person || ""}
            className="arsenal-select"
            style={dropdownStyle}
            onChange={(value) => {
              jobHandleForm({
                job: { ...currentJob, sales_person: value },
              });
            }}
            //below is test data, replace with customisable settings in future
            options={[
              { value: "", label: t("form.placeholder.selectSalesPerson") },
              ...salesPersons?.map((person) => ({
                value: person.id,
                label: person.name,
              })),
            ]}
          />
        </FloatingLabel>

        <FloatingLabel
          label={t("form.label.Location")}
          className="arsenal-select-floating-label"
        >
          <Select
            value={currentJob?.job_location || ""}
            className="arsenal-select"
            style={dropdownStyle}
            onChange={(value) => {
              jobHandleForm({
                job: { ...currentJob, job_location: value },
              });
            }}
            //below is test data, replace with customisable settings in future
            options={[
              { value: "", label: t("form.placeholder.selectLocation") },
              ...locations?.map((location) => ({
                value: location.id,
                label: location.name,
              })),
            ]}
          />
        </FloatingLabel>
      </Container>
      <Container>
        <Form>
          <Label>{t("jobBoard.selectRemainingInformation")}</Label>
          <Row>
            <Col>
              <Container>
                <Row>
                  <Col>
                    <Label>{t("jobBoard.dueDate")}:</Label>
                    {!isCompleted && (
                      <DateTimePickerInput
                        calendarIcon={
                          <img src={calendarIcon} alt="calendar range" />
                        }
                        onChange={(value) => {
                          jobHandleForm({
                            job: {
                              ...currentJob,
                              date_due: moment(value),
                            },
                          });
                        }}
                        value={
                          currentJob?.date_due
                            ? new Date(currentJob.date_due)
                            : new Date()
                        }
                        disableClock={true}
                        format={"dd MMM yyyy"}
                        monthAriaLabel="Month"
                        style={{ width: 400 }}
                      />
                    )}
                    {isCompleted && (
                      <DateTimePickerDiv>
                        {moment(currentJob.date_due).format("MM/DD/YYYY")}
                      </DateTimePickerDiv>
                    )}
                  </Col>
                </Row>
                {plugin_settings.job_board_include_price && (
                  <>
                    <Row>
                      <Col>
                        <Label>{t("jobBoard.total")}:</Label>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "row",
                          }}
                        >
                          <Form.Control
                            readOnly={isReadOnly}
                            type="text"
                            name={"layout"}
                            placeholder={t("form.placeholder.layout")}
                            value={currentJob?.discount || total}
                            as={DebounceInputStyled}
                            onChange={(e) => {
                              jobHandleForm({
                                job: {
                                  ...currentJob,
                                  discount: e.target.value,
                                },
                              });
                            }}
                            debounceTimeout={1000}
                          />
                          <LabelTotal>
                            {plugin_settings.job_board_currency}
                          </LabelTotal>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col></Col>
                    </Row>
                  </>
                )}
              </Container>
            </Col>
            <Col>
              <Label>{t("jobBoard.notes")}:</Label>
              <JobFormNoteLazy />
            </Col>
          </Row>
        </Form>
      </Container>
      <ConfirmDelete
        show={showConfirmPendingPickup}
        confirmDescription={"jobBoard.confirmPendingPickupJob"}
        confirmButtonText={"jobBoard.pendingPickupJob"}
        onHide={() => {
          setShowConfirmPendingPickup(false);
        }}
        onConfirmClick={() => {
          jobHandleForm({
            job: {
              ...currentJob,
              date_completed: moment(),
              status: "waiting_pickup",
            },
          });
          setShowConfirmPendingPickup(false);
          setShowNotifyCustomer(true);
        }}
      />
      <NotifyCustomerModal
        show={showNotifyCustomer}
        customerName={
          selectedCustomer
            ? `${selectedCustomer.firstname || ""} ${
                selectedCustomer.lastname || ""
              }`.trim()
            : ""
        }
        ballName={currentBall?.ball_name}
        onHide={() => {
          setShowNotifyCustomer(false);
          navigate(-1);
        }}
        onSkip={() => {
          setShowNotifyCustomer(false);
          navigate(-1);
        }}
        onSend={(note) => {
          jobNotifyCustomer({ jobId: currentJob?.id, extraNote: note });
          setShowNotifyCustomer(false);
          navigate(-1);
        }}
      />
      <ConfirmDelete
        show={showConfirmDelete}
        confirmDescription={"jobBoard.confirmDeleteJob"}
        confirmButtonText={"jobBoard.deleteJob"}
        onHide={() => {
          setShowConfirmDelete(false);
        }}
        onConfirmClick={() => {
          // Check if WooCommerce plugin is enabled
          if (pluginSubscriptions.indexOf("SPECTRE_POS") >= 0) {
            // Iterate over all job services for the current job
            const servicesWithSku = jobServices
              .filter((service) => service.sku)
              .map((service) => ({ ...service }));
            currentJob.job_details.forEach((jobDetail) => {
              const jobService = jobDetail.job_service;

              // Find the matching JobService in the jobServices array
              const matchingService = servicesWithSku.find(
                (service) => service.id === jobService.id
              );

              if (matchingService?.sku) {
                // Dispatch woocommerceRemoveFromOrderBySKU for the matching service with an SKU
                woocommerceCheckUserExists({
                  first_name: selectedCustomer.firstname,
                  last_name: selectedCustomer.lastname,
                  email: selectedCustomer.email,
                  spectreCustomer: selectedCustomer,
                  sku: matchingService.sku,
                  orderData: {
                    payment_method: "bacs",
                    payment_method_title: "Direct Bank Transfer",
                    set_paid: false,
                    billing: {
                      first_name: selectedCustomer?.firstname,
                      last_name: selectedCustomer?.lastname,
                      address_1: selectedCustomer?.address,
                      address_2: "",
                      city: selectedCustomer?.city,
                      state: selectedCustomer?.state,
                      postcode: selectedCustomer?.postal_code,
                      country: selectedCustomer?.country,
                      email: selectedCustomer?.email,
                      phone: selectedCustomer?.telephone,
                    },
                    shipping: {
                      first_name: selectedCustomer?.firstname,
                      last_name: selectedCustomer?.lastname,
                      company: "",
                      address_1: selectedCustomer?.address,
                      address_2: "",
                      city: selectedCustomer?.city,
                      state: selectedCustomer?.state,
                      postcode: selectedCustomer?.postal_code,
                      country: selectedCustomer?.country,
                    },
                  },
                  customerData: {
                    first_name: selectedCustomer.firstname,
                    last_name: selectedCustomer.lastname,
                    email: selectedCustomer.email,
                    username: selectedCustomer.telephone,
                    billing: {
                      first_name: selectedCustomer.firstname,
                      last_name: selectedCustomer.lastname,
                      address_1: selectedCustomer.address,
                      city: selectedCustomer.city,
                      state: selectedCustomer.state,
                      postcode: selectedCustomer.postal_code,
                      country: selectedCustomer.country,
                      email: selectedCustomer.email,
                      phone: selectedCustomer.telephone,
                    },
                    shipping: {
                      first_name: selectedCustomer.firstname,
                      last_name: selectedCustomer.lastname,
                      address_1: selectedCustomer.address,
                      city: selectedCustomer.city,
                      state: selectedCustomer.state,
                      postcode: selectedCustomer.postal_code,
                      country: selectedCustomer.country,
                    },
                  },
                  nextAction: "SKU remove",
                });
              }
            });
          }

          // Proceed with deleting the job
          jobDelete({
            id: currentJob.id,
          });
          navigate(-1);
          setShowConfirmDelete(false);
        }}
      />
      <ConfirmDelete
        show={showConfirmComplete}
        confirmDescription={"jobBoard.confirmCompleteJob"}
        confirmButtonText={"jobBoard.completeJob"}
        onHide={() => {
          setShowConfirmComplete(false);
        }}
        onConfirmClick={() => {
          jobHandleForm({
            job: {
              ...currentJob,
              date_completed: moment(),
              status: "complete",
            },
          });
          navigate(-1);
          setShowConfirmComplete(false);
        }}
      />
    </div>
    </>
  );
};

export const JobBoardBallServiceScreen = connect(
  (state) => ({
    loadingCustomer: state.bowlers.loadingCustomer,
    deviceInfo: state.userSession.deviceInfo,
    selectedCustomer: state.bowlers.selectedCustomer,
    currentBall: state.balls.currentBall,
    loadingBalls: state.balls.loading,
    balls_drilled: state.bowlers.selectedCustomer?.balls_drilled || [],
    userId: state.userSession.userData.id,
    isReadOnly: state.userSession.isReadOnly,
    currentJob: state.balls.currentJob || {},
    selectedJobServices: R.map(
      R.path(["job_service", "id"]),
      state.balls.currentJob?.job_details || []
    ),
    total: R.sum(
      R.map(R.path(["price"]), state.balls.currentJob?.job_details || [])
    ),
    jobServices: state.plugin.jobServices,
    plugin_settings: state.plugin.plugin_settings,
    isCompleted: state.balls.currentJob?.status === "complete",
    creatingJobDetails: state.balls.creatingJobDetails,
    currentSpecsheet: state.specsheet.currentSpecSheet,
    pluginSubscriptions: state.plugin.pluginSubscriptions,
    salesPersons: state.plugin.salesPersons,
    locations: state.plugin.locations,
    spanMeasurement: state.settings.appSettings.systemDefault.span_measurement,
  }),
  {
    getCustomer,
    jobHandleForm,
    jobDetailCreate,
    jobDelete,
    jobDetailDelete,
    jobNotifyCustomer,
    woocommerceCheckUserExists,
  }
)(JobBoardBallServiceScreenRedux);
